/* global requestAnimationFrame, cancelAnimationFrame */
import React, { PureComponent } from "react";
import { styled } from "baseui";
import { Slider } from "baseui/slider";
import util from "../util/util";

const Container = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1,
  width: "100%",
  marginTop: "0px"
});

const ThumbValue = styled("div", {
  position: "absolute",
  top: "-1.4em",
  fontFamily: '"Roboto"',
  fontSize: "0.8em",
  color: "#B8B8B8",
  left: "0px"
});

const TickBar = styled("div", {
  width: "300px",
  height: "24px",
  maxWidth: "80vw"
});

const ANIMATION_SPEED = 10;
//const ANIMATION_SPEED = 100;

export default class RangeInput extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isPlaying: false
    };

    this._renderThumbValue = this._renderThumbValue.bind(this);
    this._animateTimeline = this._animateTimeline.bind(this);
    this._animationFrame = null;
    this.goTo = props.min;
    this.thmbCount = 0;
  }

  componentWillUnmount() {
    cancelAnimationFrame(this._animationFrame);
  }

  componentDidMount() {
    setTimeout(() => {
      this._animateTimeline();
    }, this.props.delay);
  }

  _animateTimeline() {
    const { min, max } = this.props;
    this.goTo += ANIMATION_SPEED;

    if (this.goTo >= max) {
      this.props.onChange({
        value: [min, max]
      });
    } else {
      this.props.onChange({
        value: [min, this.goTo]
      });
      this._animationFrame = requestAnimationFrame(this._animateTimeline);
    }
  }

  _renderThumbValue({ $thumbIndex, $value }) {
    // eslint-disable-next-line
    const value = $value[$thumbIndex];
    return <ThumbValue></ThumbValue>;
  }

  render() {
    const background_color = "#dedede";
    const track_highlight_color = "#52913c";
    const steps = util.isMobile() ? 20 : 1;
    return (
      <Container>
        <Slider
          step={steps}
          {...this.props}
          overrides={{
            ThumbValue: this._renderThumbValue,
            TickBar: () => <TickBar className="tick-bar" />,
            InnerThumb: {
              style: ({ $theme }) => {
                return {
                  backgroundColor: "green"
                };
              }
            },
            Thumb: {
              style: ({ $theme }) => {
                let width = util.isMobile() ? "17px" : "12px";
                let height = util.isMobile() ? "35px" : "24px";
                return {
                  width,
                  height
                };
              }
            },
            InnerTrack: {
              style: ({
                $theme,
                $disabled,
                $isDragged,
                $max,
                $min,
                $thumbIndex,
                $value
              }) => {
                var percent_right =
                  (($value[1] - this.props.min) /
                    (this.props.max - this.props.min)) *
                  100;
                var percent_left =
                  (($value[0] - this.props.min) /
                    (this.props.max - this.props.min)) *
                  100;
                return {
                  background: `linear-gradient(to right, ${background_color} 0%, ${background_color} ${percent_left}%, ${track_highlight_color} ${percent_left}%, ${track_highlight_color} ${percent_right}%, ${background_color} ${percent_right}%, ${background_color} 100%);`
                };
              }
            }
          }}
        />
      </Container>
    );
  }
}
